var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        staticClass: "section-title__extended mt-4",
        attrs: {
          content: "Historial de Addendums",
          icon: "fas fa-history text-orange",
          reverse: ""
        }
      }),
      _vm.history.length === 0 ? _c("custom-result-not-found") : _vm._e(),
      _c(
        "time-line",
        { staticClass: "mt-4" },
        _vm._l(_vm.history, function(item, index) {
          return _c(
            "div",
            { key: `item-index-${index}` },
            [
              _c(
                "time-line-item",
                {
                  staticClass: "custom-time-line rounded",
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "icon",
                        fn: function() {
                          return [
                            _c("em", { staticClass: "fas fa-retweet radius" })
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "date",
                        fn: function() {
                          return [
                            _c("div", { staticClass: "date-container" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-black font-16 font-weight-bold fulldate"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("date")(item.date)) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-black font-12 font-weight-normal hour"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("hour")(item.date)) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                },
                [
                  _c("div", { staticClass: "row py-4 mx-3" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-2 col-sm-12 border-right" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "color-gray-12 font-weight-bold mb-2"
                          },
                          [
                            _vm._v(
                              " Addendum 0" +
                                _vm._s(_vm.history.length - index) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "color-gray-6 font-14 font-weight-normal"
                          },
                          [_vm._v(" Estatus: ")]
                        ),
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("em", {
                              staticClass: "fas fa-circle mr-2",
                              class: `font-12 color-${_vm.getStatusColor(
                                _vm.status.id
                              )}`
                            }),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "color-black font-16 font-weight-normal"
                              },
                              [_vm._v(" " + _vm._s(_vm.status.name) + " ")]
                            )
                          ]
                        )
                      ]
                    ),
                    _c("div", { staticClass: "col-md-10" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col ml-5 ml-md-5 ml-sm-0" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "color-gray-6 font-14 font-weight-normal"
                            },
                            [_vm._v(" Razón: ")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "color-black font-16 font-weight-normal"
                            },
                            [_vm._v(" " + _vm._s(item.reasons) + " ")]
                          )
                        ]),
                        _c("div", { staticClass: "col ml-5 ml-md-5 ml-sm-0" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "color-gray-6 font-14 font-weight-normal"
                            },
                            [_vm._v(" Comentario: ")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "color-black font-16 font-weight-normal"
                            },
                            [_vm._v(" " + _vm._s(item.comment) + " ")]
                          )
                        ]),
                        _c("div", { staticClass: "col ml-5 ml-md-5 ml-sm-0" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "color-gray-6 font-14 font-weight-normal"
                            },
                            [_vm._v(" Añadido por: ")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "color-black font-16 font-weight-normal"
                            },
                            [_vm._v(" " + _vm._s(item.userFullName) + " ")]
                          )
                        ])
                      ])
                    ])
                  ])
                ]
              )
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }